<div class="card-body">
  <div class="row">
    <div class="col-5"></div>
    <div class="col-2">
      <div *ngIf="loader==true">
        <app-loader style="text-align: center;"></app-loader>
      </div>
    </div>
    <div class="col-5"></div>
  </div>
  <div mat-dialog-content>
    <!-- Your content here -->
     
    <div class="card shadow-sm mb-4">
      <div class="card-header">
        <h5 class="card-title mb-0">Order Details</h5>
      </div>
      <div class="card-body p-0">
        <table class="table table-bordered table-hover mb-0 custom-table">
          <thead class="thead-light">
            <tr class="custom-table-td">
              <th>Order Number</th>
              <th>Product Display Text</th>
              <th *ngIf="showOrderDetails">Retail Price</th>
              <th>Quantity</th>
              <th *ngIf="showOrderDetails">Total Retail Price</th>
              <th *ngIf="showOrderDetails">Discount Percentage</th>
              <th *ngIf="showOrderDetails">Total Retail Cost</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Items; let i = index;">
              <td>{{item.orderNumber}}</td>
              <td>{{item.productDisplayText}}</td>
              <td *ngIf="showOrderDetails">{{item.retailPrice}}</td>
               <td>{{item.quantity}}</td>
              <td *ngIf="showOrderDetails">{{item.totalRetailPrice}}</td>
              <td *ngIf="showOrderDetails">{{item.discountPercentage}}</td>
              <td *ngIf="showOrderDetails">{{item.totalRetailCost}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer text-right">
        <button class="btnDef" mat-button (click)="closeDialog()">Close</button>
      </div>
    </div>
    

</div>